import { createIconExperiment } from "./createIconExperiment";

export const SLATE_XP_REDRAWN_ICONS_BETA = createIconExperiment({
  controlVar: "--slate-xp__control__redrawn-icons-beta",
  treatmentVar: "--slate-xp__treatment__redrawn-icons-beta",
});

export const SLATE_XP_REDRAWN_ICONS_ALPHA = createIconExperiment({
  controlVar: "--slate-xp__control__redrawn-icons-alpha",
  treatmentVar: "--slate-xp__treatment__redrawn-icons-alpha",
});
